/* eslint-disable */
// Generated by scripts/scope-tours/generate.ts (see released.ts there). Do not
// edit by hand; run `pnpm scope-tours:generate`.
//
// The day each walkthrough was released: when its entry first appeared in
// generated.ts, read once from git history and then kept. A walkthrough
// generated before its first commit carries the day it was first generated.

export const TOUR_RELEASED: Record<string, string> = {
    'create:AiAgentThread': '2026-09-07',
    'create:AiDeepResearch': '2026-09-07',
    'create:ContentAsCode': '2026-10-07',
    'create:DashboardComments': '2026-09-07',
    'create:DataApp': '2026-09-07',
    'create:Space': '2026-09-07',
    'create:VirtualView': '2026-09-07',
    'delete:VirtualView': '2026-09-10',
    'docs:semantic-layer/dimensions': '2026-09-28',
    'docs:semantic-layer/metrics': '2026-09-28',
    'manage:AiAgent': '2026-09-07',
    'manage:AiAgentDocument': '2026-10-07',
    'manage:ChangeCsvResults': '2026-09-10',
    'manage:ContentVerification': '2026-09-07',
    'manage:CustomFields': '2026-09-07',
    'manage:CustomSql': '2026-09-10',
    'manage:CustomSqlTableCalculations': '2026-09-07',
    'manage:Dashboard': '2026-09-07',
    'manage:DashboardComments': '2026-09-07',
    'manage:DataApp': '2026-09-07',
    'manage:DeletedContent': '2026-09-10',
    'manage:Document': '2026-10-06',
    'manage:Explore': '2026-09-07',
    'manage:ExportCsv': '2026-09-07',
    'manage:MetricsTree': '2026-09-10',
    'manage:PinnedItems': '2026-09-07',
    'manage:ProjectHomepage': '2026-09-07',
    'manage:SavedChart': '2026-09-07',
    'manage:Space': '2026-09-07',
    'manage:SpotlightTableConfig': '2026-09-10',
    'manage:SqlRunner': '2026-09-07',
    'manage:Tags': '2026-09-07',
    'manage:Validation': '2026-09-29',
    'manage:VerifiedContent': '2026-09-10',
    'manage:VirtualView': '2026-09-10',
    'view:AiAgent': '2026-09-10',
    'view:AiAgentDocument': '2026-10-07',
    'view:CompiledSql': '2026-09-07',
    'view:ContentAsCode': '2026-10-07',
    'view:ContentVerification': '2026-09-10',
    'view:Dashboard': '2026-09-07',
    'view:DashboardComments': '2026-09-07',
    'view:DataApp': '2026-09-10',
    'view:Document': '2026-10-06',
    'view:MetricsTree': '2026-09-10',
    'view:PinnedItems': '2026-09-07',
    'view:SavedChart': '2026-09-07',
    'view:Space': '2026-09-07',
    'view:SpotlightTableConfig': '2026-09-10',
    'view:Tags': '2026-09-07',
    'view:UnderlyingData': '2026-09-07',
};
